import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VAlert,{attrs:{"value":true,"type":"info"}},[_vm._v("\n    "+_vm._s(_vm.messageValue)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }